import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Confirmare părăsire grup (membru invitat, nu proprietarul).
export function LeaveGroupDialog({ open, onOpenChange, groupName, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[340px] rounded-3xl">
        <AlertDialogHeader>
          <AlertDialogTitle>Părăsești grupul?</AlertDialogTitle>
          <AlertDialogDescription>
            Nu vei mai vedea „{groupName}&rdquo; în contul tău. Poți fi reinvitat oricând prin link.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-xl">Anulează</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-leave-btn"
            onClick={onConfirm}
            className="rounded-xl bg-rose-500 hover:bg-rose-600"
          >
            Părăsește
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
